import { createAction, props } from '@ngrx/store';
export const setXAxisMetric = createAction('[Scatter Plot] Set X Axis Metric', props());
